import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const paragraph = css`
  margin-bottom: ${size[20]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }
`
